// 错误码及提示语
export const ERROR_CODE_SYSTEM = '-1';
export const ERROR_CODE_NOLOGIN = '-2';
export const ERROR_CODE_NOAUTH = '-3';

export default {
    common: {
        default: '系统出错{code}，请稍后再试',
        [ERROR_CODE_SYSTEM]: '网络开小差了，请稍后再试',
        [ERROR_CODE_NOLOGIN]: '需要重新登录',
        [ERROR_CODE_NOAUTH]: '无操作权限，请检查登录的账号'
    }
};

export const textAuditRefusedMessage = {
    message: '您输入的内容包含敏感信息，请合规使用本平台，可调整输入后重新生成',
    duration: 5000
};